//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from 'vuex'
export default {
  name: 'Diseaseactivityscorein28joints',
  data () {
    return {
      form: {
        data1: '',
        data2: '',
        data3: '',
        data4: ''
      },
      hasScore: false,
      disabled: false,
      descTxt: ''
    }
  },
  created () {
    this.hideLoad()
  },
  methods: {
    ...mapMutations(['hideLoad'])
  },
  computed: {
    /** 计算公式结果 */
    score () {
      let self = this
      let form = JSON.parse(JSON.stringify(self.form))
      let flag = true
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false
          } else {
            form[key] = Number(form[key])
          }
        }
      }
      let result = 0.56 * Math.sqrt(form.data1) + 0.28 * Math.sqrt(form.data2) + 0.7 * Math.log(form.data3) + 0.014 * form.data4
      if (!flag) {
        self.hasScore = false
        self.descTxt = ''
        return ''
      } else {
        self.hasScore = true
        if (result < 2.6) {
          self.descTxt = '临床缓解'
        } else if (result >= 2.6 && result <= 3.2) {
          self.descTxt = '轻微疾病活动'
        } else if (result > 3.2 && result <= 5.1) {
          self.descTxt = '中度疾病活动'
        } else {
          self.descTxt = '重度疾病活动'
        }
        return result.toFixed(2)
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/Diseaseactivityscorein28joints.vue